import { Skeleton } from "@/components/ui/skeleton"

// Skeletons compartilhados do catálogo público.
// Server-safe: sem hooks — usados tanto no CatalogContent (client, durante
// transições) quanto no loading.tsx da rota /aeronaves.

export function GridSkeleton() {
  return (
    <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="overflow-hidden rounded-xl border-[0.5px] border-slate-200 bg-white"
        >
          <Skeleton className="aspect-video rounded-none sm:aspect-16/10" />
          <div className="p-4">
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="mt-2 h-4 w-1/2" />
            <Skeleton className="mt-3 h-5 w-1/3" />
          </div>
        </div>
      ))}
    </div>
  )
}

export function ListSkeleton() {
  return (
    <div className="flex flex-col gap-3.5">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="grid grid-cols-1 gap-x-5 gap-y-0 rounded-xl border-[0.5px] border-slate-200 bg-white md:grid-cols-[200px_1fr] lg:grid-cols-[260px_1fr_auto]"
        >
          <Skeleton className="aspect-16/10 rounded-none md:row-span-2 md:aspect-auto lg:row-span-1 lg:aspect-16/10" />
          <div className="space-y-2 px-4 py-4 lg:px-0">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-5 w-60" />
            <Skeleton className="h-3.5 w-40" />
          </div>
          <div className="space-y-3 px-4 pb-4 pt-0 md:col-start-2 md:row-start-2 md:px-0 md:pb-[18px] lg:col-start-3 lg:row-start-1 lg:min-w-55 lg:py-4 lg:pr-5 lg:text-right">
            <Skeleton className="h-6 w-28 lg:ml-auto" />
            <Skeleton className="h-9 w-40 lg:ml-auto" />
          </div>
        </div>
      ))}
    </div>
  )
}
